import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { OptionType } from '@evinced-private/ui-common';

import { MOBILE_FILTER_OPTIONS } from 'src/apps/dashboard/constants/MobileDashboardDefaults';
import { getMobileAppIdFilterOptions } from 'src/apps/dashboard/services/mobileDashboardService';
import { DASHBOARD_MOBILE_APP_ID_FILTER_OPTIONS } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useMobileAppIdFilterOptionsQuery = (): Record<string, OptionType[]> => {
	const { data } = useQuery([DASHBOARD_MOBILE_APP_ID_FILTER_OPTIONS], () =>
		getMobileAppIdFilterOptions()
	);

	return useMemo(
		() => ({
			...MOBILE_FILTER_OPTIONS,
			appId: data?.appId ?? []
		}),
		[data]
	);
};
